import { render, staticRenderFns } from "./Extended-Warranty.vue?vue&type=template&id=4b5b6c0c&scoped=true"
import script from "./Extended-Warranty.vue?vue&type=script&lang=js"
export * from "./Extended-Warranty.vue?vue&type=script&lang=js"
import style0 from "./Extended-Warranty.vue?vue&type=style&index=0&id=4b5b6c0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5b6c0c",
  null
  
)

export default component.exports